export enum EOpenPoseBodyPartMask {
  FOOT = 'mask_foot',
  HAND = 'mask_hand',
}
